import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id='home' className='hero'>
      <div className='hero-background'>
        <div className='hero-image'></div>
        <div className='hero-overlay'></div>
        <div className='hero-pattern'></div>
      </div>
      <div className='hero-content'>
        <div className='hero-text animate-fade-in-up'>
          <h1 className='hero-title'>
            Professional Accounting Services for the Puget Sound Area
          </h1>
          <p className='hero-subtitle'>
            Vi Le CPA, PLLC delivers tailored solutions with a focus on quality and
            customization. We help businesses and individuals achieve their financial
            and operational goals.
          </p>
          <div className='hero-buttons'>
            <a
              href='https://calendly.com/vyle82/virtually-meeting'
              target='_blank'
              rel='noopener noreferrer'
              className='btn hero-btn-primary'
            >
              Book Virtual Appointment
            </a>
            <a
              href='#services'
              className='btn btn-secondary'
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById('services')
                  .scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Our Services
            </a>
          </div>
          <div className='hero-stats'>
            <div className='stat delay-1'>
              <h3>Professional</h3>
              <p>CPA Licensed</p>
            </div>
            <div className='stat delay-2'>
              <h3>Personalized</h3>
              <p>Tailored Solutions</p>
            </div>
            <div className='stat delay-3'>
              <h3>Virtual</h3>
              <p>Remote Appointment</p>
            </div>
            <div className='stat delay-4'>
              <h3>Established</h3>
              <p>Since 2017</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
